module.exports = __webpack_public_path__ + "img/used_help.6d6016b9.svg";